let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("i9sdu")).then(() => parcelRequire('epfvh'));